/**
 * 用户数据交互服务
 * @author  Jianbo
 * @time 2020-03-13
 */
import api from '../api'
import axios from '../axios'

class AccountService {
  /**
   * 服务端获取数据
   * @return Promise
   */
  static getCurrentUser () {
    return axios.get(api.account.auth)
  }
}

export default AccountService
